import { ProgressBar } from '@/shared/ui/progressBar'
import { useStyles } from './styles'
import { lang } from '@/shared/constants/lang'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { $lastClaimDate, $nextClaimKeyDate, $userKeys } from '@/entities/cases'
import { Icon } from '@/shared/ui/icon'
import { useTimer } from '@/shared/hooks/useTimer'
import { AppButton } from '@/shared/ui/button'
import { goToShop } from '@/app/routing/events'
import { BackgroundShading } from '@/shared/ui/backgroundShading'
import { TimeDisplay } from '@/shared/ui/timeDisplay'
import { TimeDigits } from '@/shared/constants/types'
import { useOpenDailyCase } from '@/shared/hooks/useOpenDailyCase'
import { CircularProgress } from '@mui/material'

type DailyCaseBannerProps = {
  variant?: 'primary' | 'secondary'
}

export default function DailyCaseBanner({ variant = 'primary' }: DailyCaseBannerProps) {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.main.dailyCaseBanner
  const userKeys = useUnit($userKeys)
  const nextClaimDate = useUnit($nextClaimKeyDate)
  // const nextClaimDate = '2025-03-05T13:39:00.532987Z'
  const lastClaimDate = useUnit($lastClaimDate)
  const { canUpdate, timeLeft, progressBarWidth } = useTimer(nextClaimDate, lastClaimDate)
  if (variant === 'primary') {
    return (
      <AppButton
        className={classes.root}
        onClick={() => goToShop({ tab: 1 })}
        variant="transparent"
        sx={{
          zIndex: 99,
          '& .MuiTouchRipple-root': {
            zIndex: 2,
          },
        }}
      >
        <BackgroundShading
          width="100%"
          height="100%"
          bottom="0"
          left="0"
          startColor="#11141700"
          endColor="#000000"
          zIndex={9}
        />

        <div className={classes.caseImage} />

        <div className={classes.content}>
          <h1 className={classes.title}>
            {text.yourKeys}
            <Icon view="gamedKey" width={20} />
            <span>{userKeys}</span>
          </h1>
          <Action canUpdate={canUpdate} timeLeft={timeLeft} variant={variant} />
          <span className={classes.viewRewards}>
            <p>{text.viewRewards}</p>
            <Icon view="arrowRight" width={16} />
          </span>
        </div>
        <div className={classes.progressBarWrapper}>
          <ProgressBar color="#1993DB" width={progressBarWidth} />
        </div>
      </AppButton>
    )
  }

  if (variant === 'secondary') {
    return (
      <AppButton
        className={classes.root}
        onClick={() => goToShop({ tab: 1 })}
        style={{ width: '100%', minHeight: '120px' }}
        variant="transparent"
        sx={{
          zIndex: 99,
          '& .MuiTouchRipple-root': {
            zIndex: 2,
          },
        }}
      >
        <BackgroundShading
          width="100%"
          height="100%"
          bottom="0"
          left="0"
          startColor="#11141700"
          endColor="#000000"
          zIndex={9}
        />

        <div className={classes.secondaryCaseImage} />

        <div className={classes.content} style={{ width: '50%', alignSelf: 'center', position: 'relative' }}>
          <Action canUpdate={canUpdate} timeLeft={timeLeft} variant={variant} />
        </div>
        <div className={classes.progressBarWrapper}>
          <ProgressBar color="#1993DB" width={progressBarWidth} />
        </div>
      </AppButton>
    )
  }
}

function Action({ canUpdate, timeLeft }: { canUpdate: boolean; timeLeft: TimeDigits; variant: string }) {
  const { classes } = useStyles()
  const { isOpening, openDailyCase } = useOpenDailyCase()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].pages.main.dailyCaseBanner

  if (canUpdate) {
    return (
      <div
        style={{ width: '100%', display: 'flex', alignItems: 'center' }}
        onClick={(e) => {
          e.stopPropagation()
          openDailyCase()
        }}
      >
        <div className={classes.claim}>{isOpening ? <CircularProgress size={20} /> : <h1>{text.claimReward}</h1>}</div>
      </div>
    )
  }

  if (!canUpdate) {
    return (
      <div className={classes.timeDisplayAndTextWrapper}>
        <span className={classes.freeCaseInText}>{text.freeCaseIn}</span>
        <TimeDisplay timeLeft={timeLeft} />
      </div>
    )
  }
}
